// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_fu","advertDetailServiceList__header":"c-o_fv","advertDetailServiceList__list":"c-o_fw"};